import { render, staticRenderFns } from "./shareGroup.vue?vue&type=template&id=3e798f3f&scoped=true&"
import script from "./shareGroup.vue?vue&type=script&lang=js&"
export * from "./shareGroup.vue?vue&type=script&lang=js&"
import style0 from "./shareGroup.vue?vue&type=style&index=0&id=3e798f3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e798f3f",
  null
  
)

component.options.__file = "shareGroup.vue"
export default component.exports